const modules = import.meta.glob('./*/*.{ts,json}', { eager: true });

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const deepMerge = (
  target: Record<string, unknown>,
  source: Record<string, unknown>,
) => {
  const result = { ...target };

  Object.entries(source).forEach(([key, value]) => {
    if (isObject(value) && isObject(result[key])) {
      result[key] = deepMerge(result[key] as Record<string, unknown>, value);
      return;
    }

    result[key] = value;
  });

  return result;
};

const messages: Record<string, { translation: Record<string, unknown> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.(ts|json)$/);

  if (!match) {
    return;
  }

  const [, lang] = match;
  const module = modules[path] as { default?: Record<string, unknown> };

  if (!messages[lang]) {
    messages[lang] = { translation: {} };
  }

  if (module.default) {
    messages[lang].translation = deepMerge(
      messages[lang].translation,
      module.default,
    );
  }
});

if (messages['pt-BR'] && !messages.pt) {
  messages.pt = messages['pt-BR'];
}

if (messages['en-US'] && !messages.en) {
  messages.en = messages['en-US'];
}

export default messages;
